import type { HTMLAttributes } from "react";

import type { TImageProps } from "@/ui/components/primitives/Image";
import { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const OVERLAPPING_IMAGE_GROUP_IMAGE_CONTAINER_CLASS = "relative overflow-hidden rounded-full border-2 border-sys-neutral-600";

export const OVERLAPPING_IMAGE_GROUP_SIZE_CLASS_MAP = {
  xs: "h-6 w-6 max-w-6",
  sm: "h-8 w-8 max-w-8",
  md: "h-10 w-10 max-w-10",
  lg: "h-12 w-12 max-w-12",
} as const;

export const OVERLAPPING_IMAGE_GROUP_OVERLAP_CLASS_MAP = {
  xs: "-ml-1",
  sm: "-ml-1.5",
  md: "-ml-2",
  lg: "-ml-2.5",
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TOverlappingImageGroupSize = keyof typeof OVERLAPPING_IMAGE_GROUP_SIZE_CLASS_MAP;

export type TOverlappingImageGroupProps = {
  images: TImageProps[];
  label?: string;
  size?: TOverlappingImageGroupSize;
} & HTMLAttributes<HTMLDivElement>;

type TOverlappingImageGroupDefaultProps = DefinedDefaults<
  TOverlappingImageGroupProps,
  "label" | "size"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const OVERLAPPING_IMAGE_GROUP_DEFAULTS = {
  label: "Image group",
  size: "md",
} satisfies TOverlappingImageGroupDefaultProps;
